export default {
  fetchDataSortKeys: [
    'total',
    'ticker',
    'rtd11',
    'currentEarning',
    'annualEarning',
    'newProduct',
    'supplyDemand',
    'leaderorLagard',
    'institutionalSponsorship',
    'marketDirection',
  ],
  tableCanslim: {
    TICKER: 'ticker',
    MARKET_CAP: 'rtd11',
    CURRENT_EARNING: 'currentEarning',
    ANNUAL_EARNING: 'annualEarning',
    NEW_PRODUCT: 'newProduct',
    SUPPLY_AND_DEMAND: 'supplyDemand',
    LEADER_AND_LARGARD: 'leaderorLagard',
    INSTITUTIONAL_SPONSORSHIP: 'institutionalSponsorship',
    MARKET_DIRECTION: 'marketDirection',
    TOTAL: 'total',
  },
};
